// src/composables/useCtaText.ts
import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useCtaText() {
  const route = useRoute();
  const referrer = document.referrer.toLowerCase();

  // Grab utm_term (keywords) and clean it up
  const keyword = computed(() => {
    const raw = Array.isArray(route.query.utm_term)
      ? route.query.utm_term[0] || ''
      : (route.query.utm_term as string) || '';
    return raw
      .replace(/[-+]/g, ' ')
      .trim()
      .replace(/\b\w/g, l => l.toUpperCase());
  });

  const ctaTitle = computed(() => {
    if (referrer.includes('linkedin.com') || route.query.utm_source === 'linkedin') {
      return 'Spotted Us on LinkedIn?';
    }
    if (keyword.value) {
      return `Looking for ${keyword.value}?`;
    }
    return 'Have a Question or Feedback?';
  });

  const ctaSubtitle = computed(() => {
    if (referrer.includes('google.com') || route.query.utm_source === 'google') {
      return 'You searched for ‘' + (keyword.value || 'our services') + '’—we’ve got the answers.';
    }
    if (keyword.value) {
      return `We’re here to help with all things ${keyword.value}.`;
    }
    return 'Drop us a line below and we’ll get right back to you.';
  });

  return { ctaTitle, ctaSubtitle };
}
